
const dynamicData = [
  {
    "title": "ServicesList",
    "subpages": [
        { 
            "title": "Groundwater Investigation", 
            "path": "groundWaterInvestigation",
            "page": "groundWaterInvestigation" 
        },
        { "title": "DTH & Rotary Drilling (EW, OW & Pz)", "path": "rotaryDrilling","page": "rotaryDrilling" },
        { "title": "Exploratory Tests for EW & OW (APT, SDT, PYT & Slug)", "path": "explaratoryTests","page": "explaratoryTests" },
        { "title": "Geophysical surveys (ERT, SRT & Electrical Resistivity Survey)", "path": "geophysicalSurveys","page": "geophysicalSurveys" },
        { "title": "Geophysical Logging & Interpretation", "path": "logging","page": "logging" },
        { "title": "Mineral Exploration", "path": "mineralExploration","page": "mineralExploration" },
        { "title": "Mine Planning", "path": "minePlanning","page": "minePlanning" },
        { "title": "Core Drilling", "path": "coreDrilling","page": "coreDrilling" },
        { "title": "Soil Test", "path": "soilTest","page": "soilTest" },
        { "title": "Drone Survey", "path": "droneMapping","page": "droneMapping" },
        { "title": "GIS", "path": "GIS","page": "GIS" },
        { "title": "Water Quality", "path": "waterQuality","page": "waterQuality" },
        { "title": "DGPS", "path": "dgps","page": "dgps" },
        { "title": "Geological Mapping", "path": "geologicalMapping","page": "geologicalMapping" }, 
    ],
  }
];

export default dynamicData;
